import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register klines import utility on window for console access
import "./utils/runKlinesImport";

// FORCE CACHE PURGE: Unregister any legacy service workers to resolve "Sticky Cache" issues on mobile
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
      console.log('🧹 [System] Legacy ServiceWorker Purged');
    }
  });
}

import { ErrorBoundary } from "./components/ErrorBoundary";

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

